const createOrUpdateUserBasicProfilesDetailsGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
    failure_response {
      res_status
      response
    }
  `;

  const successFields = `
    completion_percentage
  `;

  const mutation = `create_or_update_user_profile_details(user_basic_details_input: $user_basic_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation)
    return {
      mutation: `
    mutation CreateOrUpdateUserBasicProfilesDetails($user_basic_details_input: UserBasicProfilesDetailsInput!) {
      ${mutation}
    }
  `,
      type: 'UserBasicProfilesDetailsInput!'
    };
  else return { mutation, type: 'UserBasicProfilesDetailsInput!' };
};

export { createOrUpdateUserBasicProfilesDetailsGraphQlMutation };
